var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInverted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.87 13.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#ff8e00;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC81C\uBAA9 \uC5C6\uC74C-11") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape_4_copy",
    "data-name": "Shape 4 copy",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_4_copy-2",
    "data-name": "Shape 4 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5,5.86a4,4,0,0,0-1.36-.1c.16-3.18,3-5.76,3-5.76C-.53,3.56.13,8.67.13,8.67H.19A3.63,3.63,0,0,0,3,12.89a3.88,3.88,0,0,0,4.72-2.58A3.61,3.61,0,0,0,5,5.86Z",
    transform: "translate(-0.11 0)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_4_copy_3",
    "data-name": "Shape 4 copy 3",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_4_copy_3-2",
    "data-name": "Shape 4 copy 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.12,5.86a3.91,3.91,0,0,0-1.36-.1c.17-3.18,3-5.76,3-5.76C8.64,3.56,9.3,8.67,9.3,8.67h.06a3.62,3.62,0,0,0,2.77,4.22,3.88,3.88,0,0,0,4.72-2.58A3.62,3.62,0,0,0,14.12,5.86Z",
    transform: "translate(-0.11 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverted);
export default __webpack_public_path__ + "static/media/inverted.c8ae74755ace9dcdd8a944995ecff413.svg";
export { ForwardRef as ReactComponent };